// Responsive Navigation
$(function() {
	var button = $("#menu");
	var menu   = $(".nav-main");

	$(button).click(function() {
		event.preventDefault();
		menu.slideToggle();
	});

	$(window).resize(function() {
		var w = $(window).width();

		if(w > 768 && menu.is(':hidden')) {
			menu.removeAttr('style');
		}
	});
});

// Newsletter Submission

function register($form) {
	$.ajax({
	  type: $form.attr('method'),
	  url: $form.attr('action'),
	  data: $form.serialize(),
	  cache: false,
	  dataType: 'json',
	  contentType: "application/json; charset=utf-8",
	  error: function(err) {$('#package-newsletter').before('<div class="alert alert-danger alert-dismissable" id="package-newsletter-alert"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>Could not connect to the registration server. Please try again later.</div>');},
	  success: function(data) {
	    if(data.result != "success") {
	      $('#package-newsletter').before('<div class="alert alert-danger alert-dismissable" id="package-newsletter-alert"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>'+data.msg+'</div>');
	    } else {
	      $('#package-newsletter').before('<div class="alert alert-success alert-dismissable" id="package-newsletter-alert"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>'+data.msg+'</div>');
	      $('#package-newsletter-email').val('');
	    }
	  }
	});
}

$(document).ready(function() {
	$('#package-newsletter-submit').on('click', function(event) {
	  event.preventDefault();
	  $('#package-newsletter-alert').remove();
	  var $form = $('#package-newsletter');
	  register($form);
	});
});